import { useState, useEffect } from 'react';

const useTypewriter = (words, typingSpeed = 450, pause = 1500) => {
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [forward, setForward] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (forward) {
        if (subIndex < words[index].length) {
          setSubIndex((prev) => prev + 1);
        } else {
          setForward(false);
        }
      } else {
        if (subIndex > 0) {
          setSubIndex((prev) => prev - 1);
        } else {
          setForward(true);
          setIndex((prev) => (prev + 1) % words.length);
        }
      }
    }, forward ? typingSpeed : typingSpeed / 3);

    return () => clearTimeout(timeout);
  }, [subIndex, forward, index, words, typingSpeed]);

  return words[index].substring(0, subIndex);
};

export default useTypewriter;